export const SITE_URL = "https://tempulahomestay.com"
export const SITE_NAME = "Tempula Homestay"
export const SITE_IMAGE = `${SITE_URL}/home.webp`
export const SITE_LOCALE = "en_IN"

type SeoEntry = { title: string; description: string; url: string }

export function buildPageHead(
    entry: SeoEntry,
    options?: { image?: string; extraMeta?: object[] },
) {
    const { title, description, url } = entry
    const image = options?.image ?? SITE_IMAGE
    return {
        meta: [
            { title },
            { name: 'description',        content: description },
            { name: 'robots',             content: 'index, follow' },
            { property: 'og:type',        content: 'website' },
            { property: 'og:url',         content: url },
            { property: 'og:site_name',   content: SITE_NAME },
            { property: 'og:title',       content: title },
            { property: 'og:description', content: description },
            { property: 'og:image',       content: image },
            { property: 'og:locale',      content: SITE_LOCALE },
            { name: 'twitter:card',        content: 'summary_large_image' },
            { name: 'twitter:title',       content: title },
            { name: 'twitter:description', content: description },
            { name: 'twitter:image',       content: image },
            ...(options?.extraMeta ?? []),
        ],
        links: [{ rel: 'canonical', href: url }],
    }
}

export const SEO = {
    home: {
        title: `${SITE_NAME} | Nature Getaway in the Hills, West Bengal`,
        description: "Escape to Tempula Homestay — a peaceful hill retreat in West Bengal with private rooms, mountain views, home-cooked meals, and pet-friendly stays from ₹3,299/night.",
        url: `${SITE_URL}/tempula/home`,
    },
    about: {
        title: `About Us | ${SITE_NAME}`,
        description: "Learn about Tempula Homestay — our story, our owner, and why travellers choose us for an authentic hill escape in West Bengal.",
        url: `${SITE_URL}/tempula/aboutUs`,
    },
    rooms: {
        title: `Our Rooms | ${SITE_NAME}`,
        description: "Explore our cosy rooms at Tempula Homestay. Each room offers unique views, private balconies, and modern amenities in the hills of West Bengal.",
        url: `${SITE_URL}/tempula/room`,
    },
    gallery: {
        title: `Gallery | ${SITE_NAME}`,
        description: "Browse photos of Tempula Homestay — rooms, views, nature, and moments that make every stay unforgettable.",
        url: `${SITE_URL}/tempula/gallery`,
    },
    contact: {
        title: `Contact Us | ${SITE_NAME}`,
        description: "Get in touch with Tempula Homestay for booking enquiries, directions, and any questions about your stay.",
        url: `${SITE_URL}/tempula/contact`,
    },
    book: {
        title: `Book Your Stay | ${SITE_NAME}`,
        description: "Book your stay at Tempula Homestay online. Choose your room, select dates, add meals, and confirm your booking in minutes.",
        url: `${SITE_URL}/tempula/book`,
    },
    receipt: {
        title: `Booking Confirmed | ${SITE_NAME}`,
        description: "Your booking at Tempula Homestay is confirmed. Check your booking details below.",
        url: `${SITE_URL}/tempula/receipt`,
    },
} as const
